import { SxProps, Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const sectionSx = (index: number): SxProps<Theme> => ({
  py: { xs: 2, md: 4 },
  backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#ECF3FA',
});

export const wrapperSx: SxProps<Theme> = {
  maxWidth: '1200px',
  mx: 'auto',
  px: { sm: 2, lg: 4 },
  py: { xs: 2, md: 4 },
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '500px minmax(0, 1fr)' },
  columnGap: { xs: 0, md: 3 },
  rowGap: { xs: 2.5, md: 0 },
  alignItems: 'stretch',
};

export const imageColumnSx: SxProps<Theme> = {
  width: { xs: '100%', md: '500px' },
  maxWidth: '100%',
};

export const imageLinkStyle: CSSProperties = {
  display: 'block',
  width: '100%',
};

export const imageWrapSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  aspectRatio: '1 / 1',
  height: 'auto',
  borderRadius: '24px',
  overflow: 'hidden',
};

export const imageStyle: CSSProperties = {
  objectFit: 'cover',
};

export const contentColumnSx: SxProps<Theme> = {
  pt: { md: 0.5 },
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const titleLinkStyle: CSSProperties = {
  display: 'block',
  textDecoration: 'none',
};

export const titleSx: SxProps<Theme> = {
  mb: { xs: 1.5, md: 2 },
  fontSize: { xs: '20px', lg: '34px' },
  lineHeight: 1.2,
  fontWeight: 700,
  color: '#1f2d3d',
};

export const priceSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
  fontSize: { xs: '22px', lg: '26px' },
  lineHeight: 1.15,
  fontWeight: 700,
  color: '#025382',
};

export const pickupRowSx: SxProps<Theme> = {
  mt: 1.5,
  mb: 2.5,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 0.75,
  fontSize: { xs: '10px', md: '12px' },
};

export const pickupLabelSx: SxProps<Theme> = {
  color: '#3f4a57',
  fontWeight: 500,
};

export const pickupValueSx = (isClickable: boolean): SxProps<Theme> => ({
  color: '#4A78A5',
  ...(isClickable && {
    cursor: 'pointer',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    '&:hover': {
      opacity: 0.85,
    },
  }),
});

export const previewBoxSx: SxProps<Theme> = {
  position: 'relative',
  zIndex: 2,
};

export const previewTextSx: SxProps<Theme> = {
  fontSize: { xs: '12px', md: '14px' },
  lineHeight: 1.7,
  color: '#3e4a59',
  whiteSpace: 'pre-line',
};

export const readMoreSx: SxProps<Theme> = {
  display: 'inline-flex',
  mt: 0.5,
  p: 0,
  color: '#4A78A5',
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: { xs: '13px', md: '15px' },
  lineHeight: 1.5,
  cursor: 'pointer',
};

export const bookLinkStyle: CSSProperties = {
  position: 'relative',
  zIndex: 1,
  marginTop: 'auto',
  paddingTop: '24px',
  width: 'fit-content',
  textDecoration: 'none',
  alignSelf: 'flex-start',
};

export const bookButtonSx: SxProps<Theme> = {
  borderRadius: '6px',
  px: 2.5,
  py: 1,
  fontSize: '14px',
  fontWeight: 600,
  textTransform: 'none',
  backgroundColor: '#b9782a',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#9f6420',
    boxShadow: 'none',
  },
};

export const mapPreviewDialogPaperSx: SxProps<Theme> = {
  borderRadius: '12px',
  width: 'min(960px, 95vw)',
};

export const mapPreviewContentSx: SxProps<Theme> = {
  p: 2.5,
  pt: 1,
};

export const mapPreviewIframeSx: SxProps<Theme> = {
  width: '100%',
  height: { xs: '360px', md: '560px' },
  border: 0,
  borderRadius: '8px',
};

export const mapPreviewAddressSx: SxProps<Theme> = {
  mt: 2,
  color: '#1f2d3d',
  fontWeight: 500,
  fontSize: '18px',
};

export const mapPreviewLinkSx: SxProps<Theme> = {
  mt: 1,
  display: 'inline-block',
  color: '#4A78A5',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
};
